import { Class } from '../../types.js'

export function assignCommonProperties<T extends object>(
	target: T,
	source: Partial<T> | object | undefined,
	options?: {
		onlyProperties?: (keyof T)[]
		omitProperties?: (keyof T)[]
		restrictToClass?: Class<Partial<T>, [Partial<T>]>
	},
) {
	if (!source || !target) return

	if (options?.restrictToClass) source = new options.restrictToClass(source)

	for (const key in source) {
		if (
			options?.onlyProperties &&
			!options.onlyProperties.includes(key as any as keyof T)
		)
			continue
		if (
			options?.omitProperties &&
			options.omitProperties.includes(key as any as keyof T)
		)
			continue

		if (key in target) {
			const value = Reflect.get(source, key)
			Reflect.set(target, key, value)
		}
	}
}
